import React, { useEffect } from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
import { PricingTiers } from '../components/PricingTiers';
import { PricingTable } from '../components/PricingTable';
import { usePricingData } from '../hooks/usePricingData';
export function Pricing() {
  const {
    data,
    status
  } = usePricingData();
  useEffect(() => {
    document.title = 'Pricing — Ari OS';
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-black flex flex-col" style={{
    zoom: '0.9'
  }} data-id="element-1004" data-mp="3m843lpjkjgf3">
      <SiteHeader data-id="element-1005" data-mp="3h87xnkrb9eww" />

      <main className="flex-1 relative" data-id="element-1006" data-mp="3h9srt99pqvu8">
        {/* Soft brand glow behind the hero */}
        <div className="pointer-events-none absolute inset-x-0 top-0 h-[640px] bg-[radial-gradient(ellipse_at_top,rgba(136,70,222,0.14),transparent_65%)]" data-id="element-1007" data-mp="3cazr6hfiyzbh"></div>

        {/* Hero */}
        <section className="relative max-w-4xl mx-auto px-6 pt-40 pb-20 text-center" data-id="element-1008" data-mp="1ai1ugaimnml9">
          <div className="inline-block mb-8" data-id="element-1009" data-mp="1em801b4pr3ww">
            <div className="px-6 py-2 bg-gradient-to-r from-[#E9A165]/20 via-[#8846DE]/20 to-[#D25796]/20 backdrop-blur-xl border border-white/10 rounded-full" data-id="element-1010" data-mp="1ekdgo193bjux">
              <span className="text-sm font-semibold bg-gradient-to-r from-[#E9A165] via-[#8846DE] to-[#D25796] bg-clip-text text-transparent" data-id="element-1011" data-mp="14oackpuohb5c">
                PRICING
              </span>
            </div>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-[1.05] mb-8" data-id="element-1012" data-mp="1xdhfe1160mwe">
            One OS.
            <br data-id="element-1013" data-mp="22dlsdh2v6zhv" />
            Three licenses.
          </h1>
          <p className="text-xl md:text-2xl text-zinc-400 leading-relaxed max-w-2xl mx-auto" data-id="element-1014" data-mp="1nllg4mnceqql">
            Every license runs the full voice-first Ari OS. Move up when you
            need deeper AI, more cloud, and enterprise-grade control.
          </p>
        </section>

        {/* Licenses */}
        <section className="relative max-w-6xl mx-auto px-6 pb-24" data-id="element-1015" data-mp="2l326j77h2qgr">
          {status === 'loading' && <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/[0.08] rounded-3xl overflow-hidden border border-white/[0.08]" aria-hidden="true" data-id="element-1016" data-mp="2uwppyxps6y1z">
              {[0, 1, 2].map(index => <div key={index} className="bg-black px-8 py-10 space-y-4" data-id="element-1017" data-mp="2gy84z7r9fznr">
                  <div className="h-7 w-24 rounded-md bg-white/[0.06] animate-pulse" data-id="element-1018" data-mp="2gxy9j4ng50ao"></div>
                  <div className="h-9 w-32 rounded-md bg-white/[0.06] animate-pulse" data-id="element-1019" data-mp="2c0g1rhl60r49"></div>
                  <div className="h-4 w-full rounded-md bg-white/[0.04] animate-pulse" data-id="element-1020" data-mp="276vdih9djbi9"></div>
                </div>)}
            </div>}

          {status === 'error' && <div className="text-center border border-white/10 rounded-3xl py-16 px-8" data-id="element-1021" data-mp="1y9b9j0k4n13y">
              <p className="text-white text-lg font-semibold mb-2" data-id="element-1022" data-mp="1t7c4lm8qnw4w">
                Pricing is unavailable right now
              </p>
              <p className="text-zinc-500" data-id="element-1023" data-mp="1obnbo1r85dhk">
                Please refresh the page, or reach out to{' '}
                <a href="mailto:sales@realwear.com?subject=Ari%20OS%20pricing%20enquiry" className="text-[#E9A165] hover:opacity-80 transition-opacity" data-id="element-1024" data-mp="3tw0oy5kuxgp">
                  sales@realwear.com
                </a>{' '}
                and we'll walk you through the options.
              </p>
            </div>}

          {status === 'ready' && data && <PricingTiers data={data} data-id="element-1025" data-mp="3h4lccm0fzcf3" />}

          <p className="sr-only" aria-live="polite" data-id="element-1026" data-mp="3m4pwqn4h0ral">
            {status === 'loading' ? 'Loading pricing' : ''}
          </p>
        </section>

        {/* Comparison */}
        {status === 'ready' && data && <section className="relative max-w-6xl mx-auto px-6 pb-28" data-id="element-1027" data-mp="3uymfdryffll9">
            <PricingTable data={data} data-id="element-1028" data-mp="2yggf7xeaipp9" />
          </section>}

        {/* Closing CTA */}
        <section className="relative max-w-4xl mx-auto px-6 pb-32 text-center" data-id="element-1029" data-mp="32h08gpvqt964">
          <div className="h-px bg-white/[0.12] mb-16" data-id="element-1030" data-mp="2jcwt5g93gwbw"></div>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4" data-id="element-1031" data-mp="2jdeuusej02r7">
            Not sure which license fits?
          </h2>
          <p className="text-lg text-zinc-400 mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-1032" data-mp="2t2gcen0pys7a">
            Tell us about your devices and how your teams work, and we'll
            recommend the right setup.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1033" data-mp="322v8mhf81rpk">
            <a href="https://chat.ari-os.com" target="_blank" rel="noopener noreferrer" className="px-10 py-5 bg-gradient-to-r from-[#E9A165] via-[#8846DE] to-[#D25796] text-white rounded-xl hover:shadow-2xl hover:shadow-[#8846DE]/50 transition-all font-bold text-lg" data-id="element-1034" data-mp="2x4jys6oxfh7c">
              Try Ari Now
            </a>
            <a href="mailto:sales@realwear.com?subject=Ari%20OS%20pricing%20enquiry" className="px-10 py-5 bg-white/5 backdrop-blur-xl border-2 border-white/20 text-white rounded-xl hover:bg-white/10 hover:border-white/40 transition-all font-bold text-lg" data-id="element-1035" data-mp="1hpe4egcorayq">
              Talk to Us
            </a>
          </div>
        </section>
      </main>

      <SiteFooter data-id="element-1036" data-mp="3ejwd1djo5sn1" />
    </div>;
}